import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const DashboardPage = loadable(
  async () => import("~/features/dashboard/pages/DashboardView"),
  { fallback: <></> },
)
const Settings = loadable(async () => import("~/pages/settings/index"), {
  fallback: <></>,
})
const Access = loadable(async () => import("~/pages/settings/access"), {
  fallback: <></>,
})
const UsersPage = loadable(
  async () => import("~/features/users/pages/UsersPage"),
  { fallback: <></> },
)

export const dashboardRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.home,
    element: <DashboardPage />,
  },
  {
    path: APP_ROUTES.settings,
    element: <Settings />,
    children: [
      { path: "users", element: <UsersPage /> },
      { path: "access", element: <Access /> },
    ],
  },
]
